<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HWVOsy/tc-custom/9780830854783.jpg?1696025330280" alt="This image is the cover for the book Christian History in Seven Sentences, Introductions in Seven Sentences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christian History in Seven Sentences, Introductions in Seven Sentences
      </h1>
      <p class="bookDescription body article font2">
        <p> <strong>The history of the Christian church is a fascinating story.</strong> </p> <p>Since the ascension of Jesus and the birth of the church at Pentecost, the followers of Christ have experienced persecution and martyrdom, established orthodoxy and orthopraxy, endured internal division and social upheaval, and sought to proclaim the good news "to the end of the earth." How can we possibly begin to grasp the complexity of the church's story?</p> <p>In this brief volume, historian Jennifer Woodruff Tait provides a primer using seven sentences to introduce readers to the sweeping scope of church history.</p> <p>Among the sentences:</p>  "No one whatsoever should be denied the opportunity to give his heart to the observance of the Christian religion." —The Edict of Milan (AD 313) "Light from Light, true God from true God, begotten not made, of one substance from the Father." —The Nicene Creed (325) "When our Lord and Master Jesus Christ said, 'Repent,' he willed the entire life of believers to be one of repentance." —Martin Luther's <em>Ninety-Five Theses</em> (1517) "The church is confronted today, as in no preceding generation, with a literally worldwide opportunity to make Christ known." —The Edinburgh Conference (1910)  <p>Pick up and read. The story continues.</p> <p>The accessible primers in the Introductions in Seven Sentences collection act as brief introductions to an academic field, with simple organization: seven key sentences that give readers a birds-eye view of an entire discipline.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Woodruff Tait
      </h2>
      
      <p class="authorDescription body article"><p>Jennifer Woodruff Tait (PhD, Duke University) is the managing editor of <em>Christian History</em> magazine, the author of <em>The Poisoned Chalice: Eucharistic Grape Juice and Common-Sense Realism in Victorian Methodism</em>, and a priest in the Episcopal Church. She lives in Berea, Kentucky, with her husband, Edwin, and their two daughters.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2b6d9bac